// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"d229b3e8","828":"983876cd","871":"983876cd"}[chunkId] + ".chunk.css";
};